const lang = {
    'desp': 'We use Cookies to give you the best experience on our website. By continuing, you\'re agreeing to our use of Cookies. For more information, please review our %{term}.',
    'link': 'Privacy Policy',
    'accept': 'I accept',
};

export default lang;
